/*
 * @Description:
 * @Author: my2zzh <leo@easestrategy.com>
 * @Date: 2019-08-28 18:02:31
 * @LastEditTime: 2019-10-30 16:30:31
 * @LastEditors: my2zzh <leo@easestrategy.com>
 */
// const BASE_URL = 'http://192.168.0.172:8090/h5'
// const BASE_URL = 'http://sjkg.easestrategy.com/h5'
// const BASE_URL = 'http://47.104.162.67:5008/h5'
const BASE_URL = '/h5';

// 通过任意层级菜单ID获取经过该ID的所有默认（首个）菜单
const GET_DEFAULT_MENU = '/subject/1/menu-info/{menuID}/next/';

// 获取当前ID下的下级菜单
const GET_NEXT_MENU = '/subject/1/menu-info/{menuID}/down/';

// 通过菜单ID获取文章
const GET_ARTICLE = '/subject/1/menu-info/{menuID}/article/';

// 获取文章详情
const GET_ARTICLE_DETIAL = '/subject/1/article/{menuID}/';

const GET_CAROUSEL_DATA = '/subject/{subjectId}/rotary-location/'; // 获取指定位置的轮播图

const GET_FIRSR_LEVEL_MENU = '/subject/{subjectId}/menu-info/'; // 获取一级栏目

const POST_MENU_ARTICLE = '/subject/{subjectId}/menu-article/'; // 获取指定(一个或多个)栏目下的文章列表

const GET_MENU_ARTICLE = '/subject/{subjectId}/menu-info/{menuId}/article/'; // 获取栏目下的文章列表

const GET_MENU_SELF_INFO = '/subject/{subjectId}/menu-info/{menuId}/'; // 获取本栏目信息

const GET_NEXT_LEVEL_MENU = '/subject/{subjectId}/menu-info/{menuId}/down/'; // 获取下一层栏目

const GET_LINKS_INFO = '/subject/{subjectId}/link-info/'; // 获取所有链接

const GET_ARTICLE_CLICK = '/subject/{subjectId}/article/{articleId}/click/'; // 增加文章点击量

const GET_MENU_LEVELS = '/subject/{subjectId}/menu-info/{menuId}/next/'; // 获取菜单下的第一个菜单

const GET_ARTICLE_UP_MENUS = '/subject/{subjectId}/article/{articleId}/upper/'; // 获取文章的上级栏目结构

const COUNT_CLICK = '/subject/1/article/{articleId}/click/';

const SEARCH_ARTICLE = '/subject/{subjectId}/article/'; // 文章搜索

export default {
  BASE_URL,
  GET_DEFAULT_MENU,
  GET_NEXT_MENU,
  GET_ARTICLE,
  GET_ARTICLE_DETIAL,
  GET_CAROUSEL_DATA,
  GET_FIRSR_LEVEL_MENU,
  POST_MENU_ARTICLE,
  GET_MENU_ARTICLE,
  GET_MENU_SELF_INFO,
  GET_NEXT_LEVEL_MENU,
  GET_LINKS_INFO,
  GET_ARTICLE_CLICK,
  GET_MENU_LEVELS,
  GET_ARTICLE_UP_MENUS,
  COUNT_CLICK,
  SEARCH_ARTICLE,
};



// WEBPACK FOOTER //
// ./src/api/urls.js